import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  onCambioMoneda,
  onCambioUnidad,
  calcularTotales,
  cmbCedula,
  validarCantidad,
  comboprecios,
  validarCantidadForPedido,
  onCambioUnidadTres,
  round,
} from "../../util/varios";
import moment from "moment";
import CatalogoProductoExistencia from "../../catalogos/catalogoProductoExistencia";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import useTableScroll from "../useTableScroll";
import CatalogoPresupuesto from "../../catalogos/catalogoPresupuesto";

const TablaPresupuesto = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnpresupuesto = JSON.parse(
    sessionStorage.getItem("accbtnpresupuestoc")
  );

  const txtCodigoPresupuesto = useRef();
  const txtStatus = useRef();
  const txtFecha = useRef();
  const txtId = useRef([]);
  const txtIdproducto = useRef([]);
  const txtCantidad = useRef([]);
  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNombreC = useRef();
  const txtSubTotal = useRef();
  const txtExentoTotal = useRef();
  const txtDescuento = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const cmbMoneda = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [habilitadoMod, setHabilitadoMod] = useState(false);
  const [indice, setIndice] = useState(null);
  const [visible, setVisible] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [records, setRecords] = useState([]);
  const [combomoneda, setComboMoneda] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Presupuesto.");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoPresu, setCatalogoPresu] = useState(false);
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [presupuesto, setPresupuesto] = useState({
    idpresupuesto: "0",
    codigo: "000000",
    cedularif: "",
    montototal: 0.0,
    totaliva: 0.0,
    totaldescuento: 0.0,
    totalexento: 0.0,
    totalsujeto: 0.0,
    idcliente: "",
    idvendedor: "",
    fecha: moment(fechasistema).format("YYYY-MM-DD"),
    status: 0,
    idalmacen: "",
    idmoneda: "",
    valormoneda: 0.0,
  });
  const [cliente, setCliente] = useState({
    idcliente: "",
    tiporif: "J",
    rif: "",
    nombre: "",
  });
  const [vendedor, setVendedor] = useState({
    idvendedor: "",
    tiporif: "",
    rif: "",
    nombre: "",
    idalmacen: "",
  });

  let nomtabla;

  if (operacion === 4) {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
      { label: "PRODUCTO", textAlign: "center", width: "50px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "IVA", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "MONTO IVA", textAlign: "center", width: "50px" },
      { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
    ];
  } else {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
      { label: "PRODUCTO", textAlign: "center", width: "50px" },
      { label: "EXISTENCIA", textAlign: "center", width: "30px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "IVA", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "MONTO IVA", textAlign: "center", width: "50px" },
      { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
      {
        label: <i className="fas fa-trash" />,
        textAlign: "center",
        width: "20px",
      },
    ];
  }

  const headCells = nomtabla;

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
          }
          setTimeout(() => (cmbMoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarVendedor = (id) => {
    let campos =
      "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
    let nomtab = "agente as v";
    let nomid = "v.idagente";
    let nomid2 = "v.vendedor";
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setVendedor({
              idvendedor: response.data.idagente,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });

            btnAcepta.current.focus();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un vendedor con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarCliente = (rif, tecla) => {
    let campos =
      "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
    let nomtab = "agente as c";
    let nomid = "c.rif";
    let nomid2 = "c.cliente";
    let id = rif;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNombreC.current.value = response.data.nombrec;
            setCliente({
              idcliente: response.data.idagente,
              tiporif: response.data.tiporifc,
              rif: response.data.rifc,
              nombre: response.data.nombrec,
            });
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            txtNombreC.current.value = "";
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProducto = (index, idubi, idprod) => {
    let endpoint = `${op.conexion}/api/pedido/seleccionarproductoinv?idproducto=${idprod}&idalmacen=${idubi}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];
          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "no existe un producto con ese codigo en el almacen.",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "el producto ya ha sido seleccionado.",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];
              let precio = 0.0;
              let montoiva = 0.0;
              let cantie = response.data.cantidad;
              let tipouni = 0;
              let tiene_iva = false;
              let tipoprecio = parseInt(response.data.tipoprecio);

              if (parseFloat(response.data.ivaventa) > 0.0) {
                tiene_iva = true;
              }

              if (
                parseInt(response.data.tipofactor) === 0 ||
                response.data.tipofactor === null
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);

                if (tipoprecio === 1) {
                  precio = parseFloat(response.data.preciomaxi);
                } else if (tipoprecio === 2) {
                  precio = parseFloat(response.data.precioofe);
                } else if (tipoprecio === 3) {
                  precio = parseFloat(response.data.preciomayor);
                } else if (tipoprecio === 4) {
                  precio = parseFloat(response.data.preciomini);
                }

              } else {
                if (
                  response.data.idunidadventa === response.data.idunidadalterna
                ) {
                  tipouni = 1;
                  uni = [
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                  ];

                  cantie = parseFloat(response.data.cantidad);
                  cantie = Math.trunc(cantie);
                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxialter);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofealter);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayoralter);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciominialter);
                  }

                } else if (
                  response.data.idunidadventa === response.data.idunidadmedida
                ) {
                  tipouni = 0;
                  uni = [
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                  ];

                  cantie = parseFloat(
                    response.data.cantidad / response.data.valorfactor
                  );
                  cantie = Math.trunc(cantie);

                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxi);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofe);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayor);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciomini);
                  }
                }
              }

              montoiva = precio * response.data.ivaventa / 100;

              if (index !== null) {
                data[index] = {
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciobs: 0.0,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  iva: response.data.ivaventa,
                  montoiva: round(montoiva, 2),
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: response.data.tipoprecio,
                };
              } else {
                data.push({
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  preciobs: 0.0,
                  iva: response.data.ivaventa,
                  montoiva: round(montoiva, 2),
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: response.data.tipoprecio,
                });
              }

              setRecords(data);
              setTotales(calcularTotales(data));
              setIndice(index);

              if (index !== null) {
                setTimeout(() => txtCantidad.current[index].focus(), 300);
              } else {
                setTimeout(
                  () => txtCantidad.current[data.length - 1].focus(),
                  300
                );
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarpresupuesto = () => {
    const campos =
      "p.*, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
    const nomtab =
      "presupuesto as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";

    const endpoint = `${op.conexion
      }/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=codigo&id=${txtCodigoPresupuesto.current.value.trim()}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (
              response.data.status === 1 &&
              (operacion === 2 || operacion === 3)
            ) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Presupuesto ya tiene factura asociada.",
                icono: "informacion",
              });
              setActivate(false);
              txtCodigoPresupuesto.current.value = "";
              txtCodigoPresupuesto.current.focus();
              return;
            }
            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            txtStatus.current.value = response.data.status;
            txtCodigoPresupuesto.current.setAttribute("disabled", true);
            cmbRif.current.value = response.data.tiporifc;
            txtRif.current.value = response.data.rifc;
            txtNombreC.current.value = response.data.nombrec;

            for (let i = 0; i < combomoneda.length; i++) {
              if (response.data.idmoneda === combomoneda[i].idmoneda) {
                cmbMoneda.current.selectedIndex = i;
                break;
              }
            }

            setHabilitarCat(true);
            setPresupuesto({
              idpresupuesto: response.data.idpresupuesto,
              codigo: response.data.codigo,
              cedularif: response.data.cedularif,
              montototal: response.data.montototal,
              totaliva: response.data.totaliva,
              totaldescuento: response.data.totaldescuento,
              totalexento: response.data.totalexento,
              totalsujeto: response.data.totalsujeto,
              idcliente: response.data.idcliente,
              idvendedor: response.data.idvendedor,
              fecha: moment(response.data.fecha).format("YYYY-MM-DD"),
              status: response.data.status,
              idalmacen: response.data.idalmacen,
              idmoneda: response.data.idmoneda,
              valormoneda: response.data.valormoneda,
            });

            setMoneda({
              idmoneda: response.data.idmoneda,
              descripcion: response.data.descripcion,
              simbolo: response.data.simbolo,
              valormoneda: response.data.valormoneda,
              predeterminada: response.data.predeterminada,
              subpredeterminada: response.data.subpredeterminada,
            });

            setCliente({
              idcliente: response.data.idcliente,
              tiporif: response.data.tiporifc,
              rif: response.data.rifc,
              nombre: response.data.nombrec,
            });

            setVendedor({
              idvendedor: response.data.idvendedor,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });

            seleccionarDetallepresupuesto(response.data.idpresupuesto);
            if (operacion === 2) {
              setHabilitado(true);
              setHabilitadoProductos(false);
              setTimeout(() => txtFecha.current.focus(), 200);
            } else {
              setHabilitado(false);
              setTimeout(() => btnCancela.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Presupuesto con ese codigo.",
              icono: "informacion",
            });
            txtCodigoPresupuesto.current.value = "";
            txtCodigoPresupuesto.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetallepresupuesto = (idpresupuesto) => {
    let nomtab1 = "presupuesto_detalle";
    let nomtab2 = "presupuesto";
    let nomid = "idpresupuesto";
    let endpoint = `${op.conexion}/api/presupuestos/seleccionarpresupuesto?idpresupuesto=${idpresupuesto}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            let uni = [];
            let montoiva = 0.0;
            let cantie = 0.0;
            let cantiea = 0.0;
            let tipouni = 0;
            let tiene_iva = false;

            for (let i = 0; i < response.data.length; i++) {
              if (parseFloat(response.data[i].iva) > 0.0) {
                tiene_iva = true;
              }
              if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) <= 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              } else if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) > 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);

                cantiea = cantiea * parseFloat(response.data[i].valorfactor);
                cantiea = Math.trunc(cantiea);
              } else if (response.data[i].tipounidad === 1) {
                tipouni = 1;
                uni = [
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              }

              let miva = response.data[i].punitario * response.data[i].iva / 100;

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                cantidadE: parseFloat(cantie),
                cantidadEA: parseFloat(cantiea),
                nombrecorto: `${response.data[i].nombrecorto} ${tiene_iva ? "" : " (E)"
                  }`,
                precio: response.data[i].punitario,
                preciobs: response.data[i].punitariobs,
                preciomaxi: response.data[i].preciomaxi,
                precioofe: response.data[i].precioofe,
                preciomayor: response.data[i].preciomayor,
                preciomini: response.data[i].preciomini,
                preciomaxialter: response.data[i].preciomaxialter,
                precioofealter: response.data[i].precioofealter,
                preciomayoralter: response.data[i].preciomayoralter,
                preciominialter: response.data[i].preciominialter,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                montoiva: round(parseFloat(miva) * parseFloat(response.data[i].cantidad), 2),
                descuento: response.data[i].descuento,
                total: response.data[i].cantidad * response.data[i].punitario,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: tipouni,
                valormoneda: monedaCambio.valormoneda,
                idmoneda: response.data[i].idmoneda,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
                tipoprecio: response.data[i].tipopreciodeta,
              });
            }
            setTotales(calcularTotales(prod));
            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/presupuestos/actualizarpresupuesto/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            window.open(
              `${op.reportes}/ventas?afiliado=${afiliado}&reporte=Presupuesto&idnota=${response.data.idpe}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro " + response.data.idpe + " creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idpe + " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idpe + " eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, event.which);
      }
    }
  };

  const validarCantidadP = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidadForPedido({
        index: index,
        event: event,
        productos: records,
      });
      if (event.which === 13) {
        if (index < cantidades.data.length - 1) {
          setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
        }
      }
      setMensaje(cantidades.msm);
      setRecords(cantidades.data);
      setTotales(cantidades.totales);
    }
  };

  const validarIdProducto = (index) => (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
          seleccionarProducto(index, vendedor.idalmacen, event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación.",
            texto: "debe seleccionar un vendedor.",
            icono: "informacion",
          });
        }
      }
    }
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    txtNombreC.current.value = values.nombre;
    cmbRif.current.value = values.rif.substring(0, 1);
    txtRif.current.value = values.rif.substring(1);
    setCliente({
      idcliente: values.idagente,
      tiporif: values.rif.substring(0, 1),
      rif: values.rif.substring(1),
      nombre: values.nombre,
    });
  };

  const onCatalogopresupuesto = (values) => {
    setCatalogoPresu(false);
    txtCodigoPresupuesto.current.value = values.codigo;
    seleccionarpresupuesto();
  };

  const agregarProducto = (producto) => {
    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
    setMostrar(false);
  };

  const seleccionarxIndice = (index) => (e) => {
    e.preventDefault();
    if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
      setMostrar(true);
      setIndice(index);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "debe seleccionar un vendedor.",
        icono: "informacion",
      });
    }
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
      }
    }
    setRecords(elementos);
    setTotales(calcularTotales(elementos));
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: records,
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    setRecords(cambio.data);
  };

  const onChangeUnidad = (i) => (e) => {
    let cambiounidad = onCambioUnidad({
      idunidad: e.target.value,
      index: i,
      productos: records,
    });
    setMensaje(cambiounidad.msm);
    setRecords(cambiounidad.data);
    setTotales(cambiounidad.totales);
  };

  const onChangeTipoPrecio = (i) => (e) => {
    let data = [...records];
    let tipoprecio = parseInt(e.target.value);
    let tipounidad = data[i].tipounidad;
    let cantidad = data[i].cantidad;
    let precio = 0.0;
    let total = 0.0;

    if (tipounidad === 1) {
      if (tipoprecio === 1) {
        precio = parseFloat(data[i].preciomaxialter);
      } else if (tipoprecio === 2) {
        precio = parseFloat(data[i].precioofealter);
      } else if (tipoprecio === 3) {
        precio = parseFloat(data[i].preciomayoralter);
      } else if (tipoprecio === 4) {
        precio = parseFloat(data[i].preciominialter);
      }
    } else {
      if (tipoprecio === 1) {
        precio = parseFloat(data[i].preciomaxi);
      } else if (tipoprecio === 2) {
        precio = parseFloat(data[i].precioofe);
      } else if (tipoprecio === 3) {
        precio = parseFloat(data[i].preciomayor);
      } else if (tipoprecio === 4) {
        precio = parseFloat(data[i].preciomini);
      }
    }

    total = precio * cantidad;
    let montoiv = (parseFloat(precio) * parseFloat(data[i].iva)) / 100;

    data[i].tipoprecio = e.target.value;
    data[i].precio = precio;
    data[i].total = total;
    data[i].montoiva = round(montoiv * cantidad, 2);

    setRecords(data);
    setTotales(calcularTotales(data));
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (
      cmbRif.current.value === "" ||
      txtRif.current.value.trim() === "" ||
      txtNombreC.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Cliente no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancela.current.focus();
    }

    if (sigue) {
      let notae = [];
      let notaedet = [];

      notae.push({
        idpresupuesto: presupuesto.idpresupuesto,
        codigo: presupuesto.codigo,
        cedularif: cliente.tiporif + cliente.rif,
        montototal: totales.total,
        totaliva: totales.totaliva,
        totalexento: totales.exento,
        totalsujeto: totales.sujeto,
        totaldescuento: totales.descuento,
        idcliente: cliente.idcliente,
        idvendedor: vendedor.idvendedor,
        fecha: txtFecha.current.value,
        status: presupuesto.status,
        idalmacen: vendedor.idalmacen,
        idmoneda: monedaSub.idmoneda,
        valormoneda: monedaSub.valormoneda,
      });

      for (let i = 0; i < records.length; i++) {
        notaedet.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          punitario: records[i].precio,
          descuento: "0.00",
          iva: records[i].iva,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tasa: monedaSub.valormoneda,
          codproducto: records[i].codigo,
          costo: records[i].costocalculado,
          utilidad: records[i].utipreciomaxi,
          tipopreciodeta: records[i].tipoprecio,
        });
      }

      setBody({
        presu: notae,
        presudeta: notaedet,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Presupuestos.");
    setBody();
    setActivate(false);
    setHabilitado(false);
    setHabilitadoMod(false);
    setHabilitarMoneda(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    setHabilitadoProductos(true);
    setVisible(0);
    setVisibleBtn("visible");
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    setRecords([]);
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        cmbMoneda.current.selectedIndex = i;
      }
    }
    if (operacion !== 1) {
      txtCodigoPresupuesto.current.value = "";
      txtCodigoPresupuesto.current.setAttribute("disabled", true);
      txtStatus.current.value = "0";
    }

    txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
    cmbRif.current.value = "J";
    txtRif.current.value = "";
    txtNombreC.current.value = "";
    setCliente({
      idcliente: "",
      tiporif: "J",
      rif: "",
      nombre: "",
    });
    setVendedor({
      idvendedor: "",
      tiporif: "",
      rif: "",
      nombre: "",
      idalmacen: "",
    });
    setPresupuesto({
      idpresupuesto: "0",
      codigo: "000000",
      cedularif: "",
      montototal: 0.0,
      totaliva: 0.0,
      totaldescuento: 0.0,
      totalexento: 0.0,
      totalsujeto: 0.0,
      idcliente: "",
      idvendedor: "",
      fecha: moment(fechasistema).format("YYYY-MM-DD"),
      status: 0,
      idalmacen: "",
      idmoneda: "",
      valormoneda: 0.0,
    });
    setTotales({
      subtotal: 0.0,
      descuento: 0.0,
      exento: 0.0,
      sujeto: 0.0,
      iva: 16.0,
      totaliva: 0.0,
      total: 0.0,
    });
    setOperacion(0);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleInputChangeCodigo = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idnotaentre") {
          seleccionarpresupuesto();
        }
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "fecha") {
      setPresupuesto({ ...presupuesto, fecha: e.target.value });
    }
  };

  const imprimirpresupuesto = () => {
    if (
      accbtnpresupuesto &&
      accbtnpresupuesto.toString().substring(4, 5) === "1"
    ) {
      if (txtCodigoPresupuesto.current.value !== "") {
        let id = txtCodigoPresupuesto.current.value;
        window.open(
          `${op.reportes}/ventas?afiliado=${afiliado}&reporte=Presupuesto&idnota=${id}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnpresupuesto &&
        accbtnpresupuesto.toString().substring(0, 1) === "1"
      ) {
        setTituloHeader("Incluir Presupuesto.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoMod(true);
        setHabilitado(true);
        setHabilitadoCli(true);
        setHabilitadoProductos(false);
        setHabilitarMoneda(true);
        //txtCodigoPresupuesto.current.setAttribute("disabled", true);
        seleccionarVendedor(idVendedor);
        setHabilitarCat(true);
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        setTimeout(() => txtRif.current.focus(), 300);
        //txtCodigoPresupuesto.current.value = "0";
        //txtCodigoPresupuesto.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnpresupuesto &&
        accbtnpresupuesto.toString().substring(1, 2) === "1"
      ) {
        setTituloHeader("Editar Presupuesto.");
        setOperacion(op);
        txtCodigoPresupuesto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        txtCodigoPresupuesto.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnpresupuesto &&
        accbtnpresupuesto.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Presupuesto.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        txtCodigoPresupuesto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitarMoneda(false);
        setHabilitadoMod(false);
        setHabilitado(false);
        setHabilitadoCli(false);
        setHabilitadoProductos(true);
        txtCodigoPresupuesto.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnpresupuesto &&
        accbtnpresupuesto.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Presupuesto.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        txtCodigoPresupuesto.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitado(false);
        setHabilitarMoneda(true);
        setHabilitadoMod(false);
        setHabilitadoCli(false);
        setHabilitadoProductos(true);
        txtCodigoPresupuesto.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow">
            <div className="col-md-12 row border-azul mx-auto rounded py-1">
              <div className="col-md-12 row mx-auto d-flex justify-content-between mb-1">
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-4">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>

                {operacion !== 1 && (
                  <div
                    className="colfull col-pd-240 mb-3"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CODIGO:
                      </label>
                      <input
                        type="text"
                        disabled
                        autoComplete="off"
                        ref={txtCodigoPresupuesto}
                        name="idnotaentre"
                        onKeyUp={handleInputChangeCodigo}
                        onBlur={handleInputChangeCodigo}
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                        className="form-control fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        disabled={habilitarCat}
                        type="button"
                        onClick={() => setCatalogoPresu(true)}
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                )}

                {operacion !== 1 && (
                  <div
                    className="colfull col-pd-230 mb-3 mr-auto px-1"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        ESTATUS:
                      </label>
                      <select
                        ref={txtStatus}
                        style={{
                          fontWeight: "bold",
                          color:
                            presupuesto.status === 0
                              ? "#007bff"
                              : presupuesto.status === 1
                                ? "#28a745"
                                : presupuesto.status === 4
                                  ? "#dc3545"
                                  : "#000000",
                        }}
                        disabled
                        className="form-select form-select-sm text-uppercase px-1"
                        aria-label=".form-select-sm example"
                      >
                        <option value="0">PENDIENTE</option>
                        <option value="1">PROCESADO</option>
                        <option value="4">ANULADO</option>
                      </select>
                    </div>
                  </div>
                )}

                <div className="colfull col-pd-290 mb-3">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm fw-bold text-center"
                      disabled={!habilitarMoneda}
                      ref={cmbMoneda}
                      onChange={onChangeMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={index}>
                            {" "}
                            {`${item.descripcion} ${item.simbolo
                              } ${formatMoneda(
                                item.valormoneda
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-pd-220 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      type="date"
                      disabled={!habilitado}
                      ref={txtFecha}
                      name="fecha"
                      onChange={onChange}
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
              <div
                className="colfull1070 col-sm-6 mx-auto mb-1 row m-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-3 col-pd-300 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={!habilitadoCli}
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      {cmbCedula.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.value}
                        </option>
                      ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled={!habilitadoCli}
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarCliente}
                      onBlur={validarCliente}
                    />
                    <button
                      disabled={!habilitadoCli}
                      type="button"
                      onClick={() => setCatalogoCliente(true)}
                      className="btn btn-success"
                      style={{
                        visibility: visible === 0 ? "visible" : "hidden",
                      }}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      ref={txtNombreC}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 col-sm-6 mx-auto mb-1 row m-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                  <span className="fw-bold mb-1">Datos del Vendedor</span>
                  <div className="input-group input-group-sm mb-2 col-md-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      value={vendedor.tiporif + vendedor.rif}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      value={vendedor.nombre}
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="bg-light d-flex align-items-between px-0">
                            <input
                              type="text"
                              style={{
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                              }}
                              disabled={habilitadoProductos}
                              ref={(el) => (txtId.current[index] = el)}
                              className="form-control form-control-sm bg-light fs-6"
                              defaultValue={item.codigo}
                              onChange={(e) =>
                                (e.target.value = e.target.value.toUpperCase())
                              }
                              onKeyUp={validarIdProducto(index)}
                              onBlur={validarIdProducto(index)}
                            />
                            {(operacion === 1 ||
                              operacion === 2 ||
                              presupuesto.numpedido !== "") && (
                                <button
                                  type="button"
                                  style={{
                                    borderBottomLeftRadius: 0,
                                    borderTopLeftRadius: 0,
                                  }}
                                  disabled={habilitadoProductos}
                                  onClick={seleccionarxIndice(index)}
                                  className="btn btn-sm btn-primary"
                                >
                                  <i className="fas ">-</i>
                                </button>
                              )}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-start p-0 pl-2"
                            style={{ width: "150px" }}
                          >
                            {item.nombrecorto}
                          </TableCell>

                          {operacion === 4 ? (
                            ""
                          ) : (
                            <TableCell
                              className="align-middle bg-light text-end p-0 pr-2"
                              style={{ width: "150px" }}
                            >
                              {formatMoneda(
                                item.cantidadE
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                          )}

                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "20px" }}
                          >
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="cantidad"
                              disabled={!habilitadoMod}
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCantidadP(index)}
                              onBlur={validarCantidadP(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0"
                            style={{ width: 50 }}
                          >
                            <select
                              className="form-control form-control-sm fs-6"
                              style={{ width: "100%" }}
                              disabled={habilitadoProductos}
                              defaultValue={item.tipoprecio}
                              onChange={onChangeTipoPrecio(index)}
                            >
                              {comboprecios.map((item2, x) => (
                                <option key={x} value={item2.id}>
                                  {" "}
                                  {item2.nombre}{" "}
                                </option>
                              ))}
                            </select>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.precio * item.valormoneda)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.iva)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0"
                            style={{ width: 50 }}
                          >
                            <select
                              className="form-control form-control-sm fs-6"
                              style={{ width: "100%" }}
                              disabled={habilitadoProductos}
                              onChange={onChangeUnidad(index)}
                            >
                              {item.unidad &&
                                item.unidad.map((item2, x) => (
                                  <option key={x} value={item2.idunidad}>
                                    {" "}
                                    {item2.descripcion}{" "}
                                  </option>
                                ))}
                            </select>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.montoiva * item.valormoneda)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.precio * item.cantidad * item.valormoneda)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          {operacion !== 4 && operacion !== 3 && (
                            <TableCell
                              className="align-middle bg-light text-center p-0"
                              style={{ width: "20px" }}
                            >
                              <button
                                disabled={habilitadoProductos}
                                style={{
                                  visibility:
                                    (operacion === 4 || operacion === 3) &&
                                    "collapse",
                                }}
                                onClick={eliminarProducto(item)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    <TableRow
                      style={{
                        padding: "0",
                        visibility:
                          (operacion === 4 ||
                            operacion === 0 ||
                            operacion === 3) &&
                          "collapse",
                      }}
                    >
                      <TableCell className="align-middle bg-light text-center p-0 d-flex">
                        <input
                          type="text"
                          disabled={habilitadoProductos}
                          ref={txtIdproducto}
                          style={{
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                          }}
                          className="form-control form-control-sm bg-light text-right"
                          onChange={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          onKeyUp={validarIdProducto(null)}
                          onBlur={validarIdProducto(null)}
                        />
                        <button
                          type="button"
                          disabled={habilitadoProductos}
                          style={{
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0,
                          }}
                          onClick={() => setMostrar(true)}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="fas ">-</i>
                        </button>
                      </TableCell>
                      <TableCell
                        className="align-middle bg-light text-start p-0 pl-2"
                        style={{ width: "150px" }}
                      ></TableCell>

                      {operacion === 4 ? (
                        ""
                      ) : (
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "30px" }}
                        ></TableCell>
                      )}

                      <TableCell
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "20px" }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light text-end p-0 pr-2"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light text-end p-0"
                        style={{ width: "50px" }}
                      ></TableCell>
                      {operacion === 4 ? (
                        ""
                      ) : (
                        <TableCell
                          className="align-middle bg-light text-center p-0"
                          style={{ width: "20px" }}
                        ></TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-md-9 py-1 mt-auto">
                  {visibleBtn === "visible" ? (
                    <div className="col-pd-botones">
                      <div className="col-md-12 row m-0">
                        <button
                          disabled={!habilitadoBot}
                          ref={btnIncluir}
                          onClick={onBotones(1)}
                          className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                          title="Incluir Presupuesto"
                        >
                          <i className="fas fa-plus"> Incluir </i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnConsultar}
                          onClick={onBotones(4)}
                          className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                          title="Consultar Presupuesto"
                        >
                          <i className="fas fa-eye"> Consultar</i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnEditar}
                          onClick={onBotones(2)}
                          className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                          title="Modificar Presupuesto"
                        >
                          <i className="fa fa-edit"> Modificar</i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnEliminar}
                          onClick={onBotones(3)}
                          className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                          title="Eliminar Presupuesto"
                        >
                          <i className="fa fa-trash"> Eliminar</i>{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-pd-360 row m-0 ml-auto">
                      {operacion === 4 ? (
                        <button
                          onClick={imprimirpresupuesto}
                          disabled={operacion === 4 ? false : true}
                          className="btn btn-sm col ml-1 btn-primary rounded-pill"
                          title="Imprimir Presupuesto"
                        >
                          <i className="fa fa-print"> Imprimir</i>
                        </button>
                      ) : (
                        ""
                      )}

                      <button
                        ref={btnAcepta}
                        disabled={operacion === 4 ? true : habilitadoBot}
                        onClick={onBotones(5)}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        ref={btnCancela}
                        disabled={habilitadoBot}
                        onClick={onBotones(6)}
                        className="btn btn-danger col ml-1 btn-sm rounded-pill"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="col-md-3 border-azul rounded shadow"
                  style={{ backgroundColor: "#dbeeff" }}
                >
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      SUBTOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtSubTotal}
                      value={formatMoneda(
                        (totales.subtotal * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      EXENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtExentoTotal}
                      value={formatMoneda(
                        (totales.exento * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      DESCUENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtDescuento}
                      value={formatMoneda(
                        (totales.descuento * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      IVA Sobre % {monedaCambio.simbolo}:{" "}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotIva}
                      value={formatMoneda(
                        (totales.totaliva * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      TOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotal}
                      value={formatMoneda(
                        (totales.total * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoProductoExistencia
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
        idalmacen={vendedor.idalmacen}
      />
      <CatalogoCliente
        show={catalogoCliente}
        nomid="cliente"
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />

      <CatalogoPresupuesto
        show={catalogoPresu}
        nomid="presupuesto"
        onHideCancelar={() => setCatalogoPresu(false)}
        onHideAceptaCatalogo={onCatalogopresupuesto}
        condicion="true"
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaPresupuesto;



// WEBPACK FOOTER //
// ./src/components/ventas/tablaPresupuesto.js